/**
 * NifCif Directive
 */
/* jshint ignore:start */
(function (itxApp) {

    'use strict';

    angular.module('itxApp.common')
        .directive('itxNifCif', ItxNifCifVrt);

    /**
     * Validate Nifs or Cif by country
     */
    function ItxNifCifVrt() {
        return {
            restrict: 'A',
            require: '?ngModel',
            link: function (scope, element, attrs, ctrl) {
                var countryCode = (attrs.itxNifCifCountry ? attrs.itxNifCifCountry : attrs.itxNifCountry) || inditex.iStoreJSON.countryCode;
                delete ctrl.$validators.nifcif;
                ctrl.$validators.nifcif = function (modelValue) {
                    var validatorNif, validatorCif, result = null;
                    
                    if (ctrl.$isEmpty(modelValue)) {
                        // consider empty models to be valid
                        return true;
                    }
                        validatorNif = joyr.validation.regex.nif()[countryCode];
                        validatorCif = joyr.validation.regex.cif()[countryCode];
                        //If not validator, then valid
                        if (!validatorNif && !validatorCif) {
                            return true;
                        }
                        var resultNif = validatorNif ? validatorNif.regExp.exec(modelValue) : true;
                        var resultCif = validatorCif ? validatorCif.regExp.exec(modelValue) : true;
                    if (resultNif || resultCif) {
                        ctrl.$setValidity('nif', resultNif ? validatorNif.parse(resultNif).isValid()
                                                            : validatorCif ? validatorCif.parse(resultCif).isValid() : true);
                        return true;
                    }
                    ctrl.$setValidity('nif', false);
                    return false;
                };
            }
        };
    }

    /** Public */
    itxApp.common.ItxNifCifVrt = ItxNifCifVrt;

})(window.itxApp);
/* jshint ignore:end */